import React, { useEffect, useMemo, useState } from "react";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function GenerarPinesPlayeros({
  onClose = () => {},
  onSaved = () => {},
}) {
  // ============================
  //        ESTADO
  // ============================
  const [cantidad, setCantidad] = useState("");
  const [estacion, setEstacion] = useState(null);

  const [saving, setSaving] = useState(false);
  const [saveErr, setSaveErr] = useState("");

  // ============================
  //        VALIDACIÓN
  // ============================
  const isValid = useMemo(() => {
    const cant = Number(cantidad);
    return cant > 0 && !!estacion;
  }, [cantidad, estacion]);

  // ============================
  //  CERRAR CON ESC
  // ============================
  useEffect(() => {
    const esc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onClose]);

  // ============================
  //        ACCIONES
  // ============================
  const handleGuardar = async () => {
    if (!isValid || saving) return;

    setSaving(true);
    setSaveErr("");

    try {
      const payload = {
        eessId: estacion.id,
        numero: Number(cantidad), // cantidad
      };

      await appFetchJson(
        apiRoutes.pines.generarPlayero,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
        {
          showSuccess: true,
          successMessage: "Pines generados correctamente",
          onSuccessClose: () => {
            onSaved(); // cierra + refresca
          },
        }
      );

    } catch (e) {
      console.error(e);
      setSaveErr(
        e?.message || "Error al generar pines. Intente nuevamente."
      );
    } finally {
      setSaving(false);
    }
  };

  // ============================
  //        RENDER
  // ============================
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-panel-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {/* ================= HEADER ================= */}
        <div className="modal-header">
          <h2 className="section-title">Generar Pines</h2>
        </div>

        {/* ================= BODY ================= */}
        <div className="modal-body">
          {saveErr && (
            <div className="mb-3 text-red-600">{saveErr}</div>
          )}

          {/* Card principal */}
          <div className="border rounded-lg bg-white overflow-visible">
            <div className="px-6 py-4 border-b modal-footer">
              <h2 className="section-title">
                Introduzca los datos de Pin
              </h2>
            </div>

            <div className="px-6 py-6 space-y-4">
              {/* Cantidad */}
              <div className="grid grid-cols-[140px_1fr] items-center gap-3 max-w-xl">
                <label className="label-strong text-right">
                  Cantidad:
                </label>
                <input
                  type="number"
                  min="1"
                  className="input"
                  value={cantidad}
                  onChange={(e) => setCantidad(e.target.value)}
                />
              </div>

              {/* EE.SS */}
              <div className="grid grid-cols-[140px_1fr] items-center gap-3 max-w-xl">
                <label className="label-strong text-right">
                  EE.SS:
                </label>
                <EessAutocomplete
                  value={estacion}
                  onChange={setEstacion}
                  placeholder="Buscar EE.SS..."
                />
              </div>
            </div>
          </div>
        </div>

        {/* ================= FOOTER ================= */}
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar
              isValid={isValid}
              saving={saving}
              onClick={handleGuardar}
            />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}
